export default "__VITE_ASSET__D3qYYpt9__"